<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label>{{ 'components.request-income-type.name' | translate }}</mat-label>
            <input
                matInput
                required
                name="name"
                [(ngModel)]="incomeTypeRequest.name"
                minlength="3"
                #name="ngModel"
                placeholder="{{ 'components.request-income-type.namePlaceholder' | translate }}"
                type="text"
            />
            <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
        </mat-form-field>
        <mat-form-field class="columns-12">
            <mat-label>{{ 'components.request-income-type.description' | translate }}</mat-label>
            <input
                matInput
                required
                name="description"
                [(ngModel)]="incomeTypeRequest.description"
                minlength="3"
                #description="ngModel"
                placeholder="{{ 'components.request-income-type.descriptionPlaceholder' | translate }}"
                type="text"
            />
            <mat-error *ngIf="description.invalid">{{ description.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'components.request-income-type.selectT4Box' | translate }}</mat-label>
            <mat-select
                placeholder="{{ 'components.request-income-type.selectOptions' | translate }}"
                multiple
                name="t4BoxSelect"
                #t4BoxSelect="ngModel"
                [(ngModel)]="incomeTypeRequest.t4Boxes"
            >
                <mat-option *ngFor="let t4BoxOption of t4BoxService.t4BoxOptions" [value]="t4BoxOption.boxNumber">
                    {{ 'components.request-income-type.box' | translate: { code: t4BoxOption.boxNumber } }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'components.request-income-type.selectRl1Box' | translate }}</mat-label>
            <mat-select
                placeholder="{{ 'components.request-income-type.selectRl1Options' | translate }}"
                multiple
                name="rl1BoxSelect"
                #rl1BoxSelect="ngModel"
                [(ngModel)]="incomeTypeRequest.rl1Boxes"
            >
                <mat-option *ngFor="let rl1BoxOption of rl1BoxService.rl1BoxOptions" [value]="rl1BoxOption.code">
                    {{ 'components.request-income-type.box' | translate: { code: rl1BoxOption.code } }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <h5 class="align-left margin-top-0 margin-bottom-1">
            {{ 'components.request-income-type.frequencyAndCalculation' | translate }}
        </h5>

        <div class="flex align-items-center">
            <mat-checkbox name="measuredInHours" [(ngModel)]="incomeTypeRequest.hasHours">{{
                'components.request-income-type.measuredInHours' | translate
            }}</mat-checkbox>
            <ui-info
                class="margin-left-1 multiline-tooltip"
                text="components.request-income-type.measuredInHoursTooltip"
            ></ui-info>
        </div>

        <mat-form-field *ngIf="incomeTypeRequest.hasHours" class="columns-12 margin-top-1 margin-bottom-1">
            <mat-label>{{ 'components.request-income-type.multiplier' | translate }}</mat-label>
            <input
                matInput
                required
                name="multiplier"
                [(ngModel)]="incomeTypeRequest.multiplier"
                [min]="0"
                #multiplier="ngModel"
                type="number"
            />
            <mat-hint>{{ 'components.request-income-type.multiplierHint' | translate }}</mat-hint>
            <mat-error *ngIf="multiplier.invalid">{{ multiplier.errors | formErrors }}</mat-error>
        </mat-form-field>

        <div class="flex align-items-center">
            <mat-checkbox name="setAsRecurring" [(ngModel)]="incomeTypeRequest.recurrable">{{
                'components.request-income-type.setAsRecurring' | translate
            }}</mat-checkbox>
            <ui-info class="margin-left-1" text="components.request-income-type.setAsRecurringTooltip"></ui-info>
        </div>

        <div class="flex align-items-center">
            <mat-checkbox name="useBonusTaxMethod" [(ngModel)]="incomeTypeRequest.bonusTax">{{
                'components.request-income-type.useBonusTaxMethod' | translate
            }}</mat-checkbox>
            <ui-info class="margin-left-1" text="components.request-income-type.useBonusTaxMethodTooltip"></ui-info>
        </div>

        <h5 class="align-left margin-top-3 margin-bottom-1">
            {{ 'components.request-income-type.applicableTaxesAndPremiums' | translate }}
        </h5>

        <mat-checkbox class="columns-12 align-left" name="taxable" [(ngModel)]="incomeTypeRequest.taxable">{{
            'components.request-income-type.incomeTax' | translate
        }}</mat-checkbox>
        <mat-checkbox class="columns-12 align-left" name="pensionable" [(ngModel)]="incomeTypeRequest.pensionable">{{
            'components.request-income-type.cppOrQpp' | translate
        }}</mat-checkbox>
        <mat-checkbox class="columns-12 align-left" name="insurable" [(ngModel)]="incomeTypeRequest.insurable">{{
            'components.request-income-type.eiOrQpip' | translate
        }}</mat-checkbox>

        <div class="flex align-items-center">
            <mat-checkbox name="employersPayrollTax" [(ngModel)]="incomeTypeRequest.eptable">{{
                'components.request-income-type.employersPayrollTax' | translate
            }}</mat-checkbox>
            <ui-info class="margin-left-1" text="components.request-income-type.employersPayrollTaxTooltip"></ui-info>
        </div>

        <div class="flex align-items-center">
            <mat-checkbox name="assessable" [(ngModel)]="incomeTypeRequest.assessable">{{
                'components.request-income-type.assessable' | translate
            }}</mat-checkbox>
            <ui-info class="margin-left-1" text="components.request-income-type.assessableTooltip"></ui-info>
        </div>
        <div class="flex align-items-center">
            <mat-checkbox name="vacationable" [(ngModel)]="incomeTypeRequest.vacationable">{{
                'components.request-income-type.vacationable' | translate
            }}</mat-checkbox>
            <ui-info class="margin-left-1" text="components.request-income-type.vacationableTooltip"></ui-info>
        </div>
    </div>
</form>
